import { useQuery, QueryResult } from '@eika-infrastruktur/react-query';

import type { Advisor } from '../generated-types';
import { getAdvisor, getImage } from '../services/advisorService';

export const useAdvisor = (): QueryResult<Advisor> =>
    useQuery({
        queryKey: ['advisor'],
        queryFn: getAdvisor,
        staleTime: Infinity,
    });

export const useAdvisorImage = (email?: string): QueryResult<string | undefined> =>
    useQuery({
        queryKey: ['advisorImage', email],
        queryFn: () => getImage(email),
        enabled: !!email,
    });
